import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "../../styles/styles";

const STEPS = [
    { id: 1, label: "1.Shipping", path: "/checkout" },
    { id: 2, label: "2.Payment", path: "/payment" },
    { id: 3, label: "3.Success", path: "/order/success" },
];

const hasCheckoutOrderReady = () => {
    try {
        const raw = localStorage.getItem("latestOrder");
        if (!raw) return false;
        const data = JSON.parse(raw);
        return Array.isArray(data?.cart) && data.cart.length > 0;
    } catch {
        return false;
    }
};

const isStepClickable = (stepId, active) => {
    if (stepId < active) return true;
    if (stepId === 2 && active === 1 && hasCheckoutOrderReady()) return true;
    return false;
};

const StepPill = ({ step, active, onNavigate }) => {
    const isCurrent = step.id === active;
    const isClickable = isStepClickable(step.id, active) && !isCurrent;
    const isFilled =
        step.id < active ||
        isCurrent ||
        (step.id === 2 && active === 1 && hasCheckoutOrderReady());

    const buttonClass = isFilled
        ? styles.cart_button
        : `${styles.cart_button} !bg-[#CCBEA1]`;
    const textClass = isFilled
        ? styles.cart_button_text
        : `${styles.cart_button_text} !text-[#38513B]`;

    if (isClickable) {
        return (
            <button
                type="button"
                onClick={() => onNavigate(step.path)}
                className={`${buttonClass} hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#38513b]/50`}
                aria-label={`Go to ${step.label.replace(/^\d\./, "")}`}
            >
                <span className={textClass}>{step.label}</span>
            </button>
        );
    }

    return (
        <div className={buttonClass} aria-current={isCurrent ? "step" : undefined}>
            <span className={textClass}>{step.label}</span>
        </div>
    );
};

const CheckoutSteps = ({ active = 1 }) => {
    const navigate = useNavigate();

    const connectorAfter = (stepId) =>
        stepId < active ||
        (stepId === 1 && active === 1 && hasCheckoutOrderReady())
            ? "w-[30px] 800px:w-[70px] h-[4px] !bg-[#38513B]"
            : "w-[30px] 800px:w-[70px] h-[4px] !bg-[#CCBEA1]";

    return (
        <div className="w-full flex justify-center checkout-steps">
            <div className="w-[90%] 800px:w-[50%] flex items-center flex-wrap">
                <div className={styles.noramlFlex}>
                    <StepPill step={STEPS[0]} active={active} onNavigate={navigate} />
                    <div className={connectorAfter(1)} />
                </div>

                <div className={styles.noramlFlex}>
                    <StepPill step={STEPS[1]} active={active} onNavigate={navigate} />
                </div>

                <div className={styles.noramlFlex}>
                    <div className={connectorAfter(2)} />
                    <StepPill step={STEPS[2]} active={active} onNavigate={navigate} />
                </div>
            </div>
        </div>
    );
};

export default CheckoutSteps;
